export default __webpack_public_path__ + "static/media/Scuba Diving.a4b1bf03.svg";